<div class="field-checkbox">
  <div class="flex align-items-center gap-2">
    <p-checkbox [formControl]="formControl" [disabled]="formControl.disabled" [ngClass]="{ 'p-disabled': formControl.disabled }" [binary]="true" [inputId]="id"> </p-checkbox>
    <label [for]="id" class="ml-2">
      {{ props.label }}
      <span class="text-red-500" *ngIf="props.required">*</span>
    </label>
  </div>

  @if (props.description) {
    <div class="text-sm text-surface-600 dark:text-surface-400 mt-1">
      {{ props.description }}
    </div>
  }
</div>
